import { Suspense } from 'react';

import ResetPasswordForm from '@/components/forms/reset-password-form';
import LoadingSpinner from '@/components/loading-spinner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ResetPasswordPage = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Card className="w-[500px]">
        <CardHeader>
          <CardTitle>비밀번호 설정</CardTitle>
        </CardHeader>
        <CardContent>
          <ResetPasswordForm />
        </CardContent>
      </Card>
    </Suspense>
  );
};

export default ResetPasswordPage;
